/**
 * Shared layout primitives for dark demo workbenches.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import React from "react";
import { cn } from "../../styling/composeClassNames.js";

export interface DemoWorkbenchStackProps {
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly gap?: number;
  readonly style?: React.CSSProperties;
}

export function DemoWorkbenchStack({
  children,
  className,
  gap = 16,
  style,
}: DemoWorkbenchStackProps): React.JSX.Element {
  return (
    <div
      className={cn("demo-workbench-stack", className)}
      style={{ display: "flex", flexDirection: "column", gap, ...style }}
    >
      {children}
    </div>
  );
}
